import { Component,ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IPreRegister} from '../../models/register.model';
import { RegisterService} from '../../services/register.service';
import { ConfirmPasswordValidator } from "../../../shared/validators";
import {LocalStorageService} from 'ngx-webstorage';
import {MessageService} from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  providers: [MessageService],
})
export class RegisterComponent implements OnInit {
  preregisterForm: FormGroup;
  myForm:FormGroup;
  loading = false;
  submitted = false;
  currentUser;
  RoleArray: any = ['Super Admin','Admin','Employee'];
  activeRoute: any;
  countries: { name: string; code: string; }[];
  constructor(
    private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private registerService: RegisterService,
        private storage: LocalStorageService,
        private messageService: MessageService,
        private spinner: NgxSpinnerService
  ) {  this.currentUser = this.storage.retrieve('currentuser');
  
  this.countries = [
    {name: 'USA', code: 'USA'},
    {name: 'India', code: 'IN'},
    {name: 'Pakistan', code: 'PAK'},
    {name: 'Istanbul', code: 'IST'},
    {name: 'Paris', code: 'PRS'}
  ];     }

  ngOnInit(): void {
    this.reactiveForm();  
  }
  get preRegisterFormControl() {
    return this.preregisterForm.controls;
  } 
  reactiveForm() {
    this.preregisterForm = this.formBuilder.group({
       firstName: ['', Validators.required],
       lastName: ['', Validators.required],
       adminEmailId:['',[Validators.required, Validators.email]],
       vendorEmailId:['',[Validators.required, Validators.email]],
       vendorName:['', Validators.required],
       verifyVendorName:[''],
       vendorShortName:[''],
       addressLine1:['', Validators.required],
       addressLine2:[''],
       webAddress:['', Validators.required],
       taxIdNumber:['', Validators.required],
       state:[''],
       city:[''],
       zipCode:[''], 
    });
  }
  
  onPreRegister({value}: {value:IPreRegister}): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);
    // this.registerService.preRegister(value).subscribe((data: any) => {
    //   this.showSuccess();
    //   this.router.navigateByUrl('/login');
    // });
  }

  showSuccess() {
    this.messageService.add({severity:'success', summary: 'Success', detail: 'Registered'});
  }
}
